import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { AuthServices } from '../services/auth.services';

@Injectable()
export class RoleGuard {
  constructor(private authServices: AuthServices, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const requiredRoles: string[] = route.data['roles'] ?? [];
    return this.authServices.getUserRoles().pipe(
      map((roles) => requiredRoles.some((r) => roles?.includes(r))),
      tap((allowed) => {
        if (!allowed) this.router.navigate(['/']);
      }),
    );
  }
}
